import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  centered: {
    display: 'flex',
    justifyContent: 'center',
  },
  header: {
    height: '30px',
    width: '70%',
    marginBottom: '1rem',
  },
  selectorControls: {
    height: '40px',
    marginBottom: '1rem',
  },
  content: {
    height: '400px',
    marginBottom: '1rem',
  },
  reels: {
    height: '30px',
    width: '15%',
    marginBottom: '1rem',
  },
  disclaimer: {
    height: '30px',
    width: '45%',
    marginBottom: '1rem',
  },
};

const SkeletonHeroMonthlyHistogram = (props) => {
  const [className, style] = useStyles(props);
  const { header, centered, selectorControls, content, reels, disclaimer } = styles;

  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonHeroMonthlyHistogram"
    >
      <Row>
        <Col style={centered}>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col md="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
        <Col md="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
        <Col md="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Box className="fr-skeleton-element" style={content} />
        </Col>
      </Row>
      <Row>
        <Col style={centered}>
          <Box className="fr-skeleton-element" style={reels} />
        </Col>
      </Row>
      <Row>
        <Col style={centered}>
          <Box className="fr-skeleton-element" style={disclaimer} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonHeroMonthlyHistogram.componentName = 'SkeletonHeroMonthlyHistogram';

export default SkeletonHeroMonthlyHistogram;
